import { useTranslation } from 'react-i18next'

import { getColorWithOpacity } from '../../../../utils/color'
import { Tag, TAG_APPEARANCE, TAG_HEIGHT } from '../../../Tag'
import {
  MATCH_CRITERION_STATUSES,
  QA_NAME_MATCH_CRITERION_CHIP,
} from '../RentalPortalMatch.constants'

import { getMatchCriterionChipTooltip } from './RentalPortalMatchCriterionChip.utils'

function RentalPortalMatchCriterionChip({
  className,
  criterion,
  height = TAG_HEIGHT.height24,
  text,
}) {
  const { t } = useTranslation()

  const { textColor } = MATCH_CRITERION_STATUSES[criterion.status]

  return (
    <Tag
      appearance={TAG_APPEARANCE.filled}
      backgroundColor={getColorWithOpacity(textColor)}
      className={className}
      height={height}
      qaName={QA_NAME_MATCH_CRITERION_CHIP}
      text={text}
      textColor={textColor}
      tooltip={getMatchCriterionChipTooltip({ criterion, t })}
    />
  )
}

export default RentalPortalMatchCriterionChip
